/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  GetPathParameters,
  PersonaDTO,
  PersonaRequest,
  UpdatePathParameters,
  _DeletePathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getPersona = () => {
  /**
 * Get persona by ID

Required authority: PERM_SUPER_ADMIN
 */
  const get = ({ id }: GetPathParameters) => {
    return customInstance<PersonaDTO>({ url: `/api/sms-simulator/personas/${id}`, method: "GET" });
  };
  /**
 * Update a persona

Required authority: PERM_SUPER_ADMIN
 */
  const update = ({ id }: UpdatePathParameters, personaRequest: PersonaRequest) => {
    return customInstance<PersonaDTO>({
      url: `/api/sms-simulator/personas/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: personaRequest,
    });
  };
  /**
 * Delete persona by ID

Required authority: PERM_SUPER_ADMIN
 */
  const _delete = ({ id }: _DeletePathParameters) => {
    return customInstance<void>({ url: `/api/sms-simulator/personas/${id}`, method: "DELETE" });
  };
  /**
 * Get all personas

Required authority: PERM_SUPER_ADMIN
 */
  const getAllPersonas = () => {
    return customInstance<PersonaDTO[]>({ url: `/api/sms-simulator/personas`, method: "GET" });
  };
  /**
 * Create a persona

Required authority: PERM_SUPER_ADMIN
 */
  const create2 = (personaRequest: PersonaRequest) => {
    return customInstance<PersonaDTO>({
      url: `/api/sms-simulator/personas`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: personaRequest,
    });
  };
  return { get, update, _delete, getAllPersonas, create2 };
};
export type GetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPersona>["get"]>>>;
export type UpdateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPersona>["update"]>>
>;
export type _DeleteResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPersona>["_delete"]>>
>;
export type GetAllPersonasResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPersona>["getAllPersonas"]>>
>;
export type Create2Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPersona>["create2"]>>
>;
